import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CallIcon = ({
  width = 48,
  color = 'foraBlue',
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <defs>
        <path d="M0 0L55.71 0 55.71 55.711 0 55.711z" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(12 12)">
        <path
          fill={getSemanticTextColor(color)}
          d="M52.878 39.932l-7.1-3.824c-1.73-.93-3.073-.257-4.563 1.79-3.265 4.494-4.852 5.383-8.86 3.143-3.745-2.086-6.424-4.566-9.786-7.925-3.36-3.36-5.844-6.036-7.934-9.777-2.236-4.006-1.35-5.59 3.148-8.855 2.05-1.488 2.722-2.83 1.791-4.557l-3.827-7.095C14.18-.185 11.964-.53 8.688.582 4.165 2.107-.214 8.636.008 11.733c.65 9.05 5.185 19.925 14.625 29.357 9.434 9.432 20.32 13.964 29.379 14.613 3.1.22 9.59-4.198 11.12-8.716 1.108-3.279.763-5.493-2.254-7.056"
        />
        <path
          fill={getSemanticTextColor(color)}
          d="M47.813 7.973C43.498 3.661 37.685 1.291 31.65 1.321c-1.496.006-2.702 1.223-2.699 2.716.006 1.493 1.217 2.7 2.71 2.7.017-.003.05 0 .076 0 4.626 0 8.972 1.796 12.245 5.066 3.284 3.282 5.083 7.65 5.067 12.299-.003 1.495 1.206 2.71 2.702 2.715h.008c1.493 0 2.705-1.203 2.71-2.696.02-6.103-2.342-11.838-6.657-16.148M31.64 12.617c-1.496.01-2.7 1.234-2.688 2.727.011 1.49 1.226 2.685 2.708 2.685h.078c1.61 0 3.12.621 4.256 1.758 1.145 1.145 1.769 2.674 1.755 4.303-.011 1.493 1.19 2.716 2.688 2.727h.022c1.488 0 2.696-1.197 2.708-2.685.027-3.092-1.162-5.994-3.343-8.175-2.181-2.181-5.131-3.323-8.184-3.34"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
